import { Button, Card, CardContent } from "@repo/ui";
import { useAuth } from "@stardeck-customer-apps/project-auth";
import { useNavigate } from "react-router-dom";

import { useTestAuthApi } from "@/lib/queries/use-test-auth-api";

export function Home() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const testApiMutation = useTestAuthApi();

  return (
    <div className="min-h-[80vh] flex flex-col">
      <section className="container mx-auto px-6 pt-24 pb-16 text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-accent px-4 py-1 text-xs font-medium text-muted-foreground">
          Stardeck • Admin Preview
        </div>
        <h1 className="mt-6 text-4xl md:text-6xl font-extrabold tracking-tight">
          A minimal login and admin preview, beautifully simple
        </h1>
        <p className="mt-4 text-muted-foreground text-base md:text-lg max-w-2xl mx-auto">
          Log in and jump straight into a protected admin area. Clean, fast, and powered by your
          existing auth.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          {isAuthenticated ? (
            <Button onClick={() => navigate("/admin")}>Go to Admin</Button>
          ) : (
            <Button onClick={() => navigate("/login")}>Log in</Button>
          )}
          <Button
            variant="outline"
            onClick={() => testApiMutation.mutate()}
            disabled={testApiMutation.isPending}
          >
            {testApiMutation.isPending ? "Testing…" : "Test Auth API"}
          </Button>
        </div>
      </section>

      <section className="container mx-auto px-6 pb-24">
        {(testApiMutation.data || testApiMutation.error) && (
          <Card className="max-w-3xl mx-auto">
            <CardContent className="p-6">
              {testApiMutation.data && (
                <div>
                  <h3 className="font-semibold mb-2">API Response</h3>
                  <pre className="text-sm overflow-auto bg-secondary rounded-md p-4">
                    {JSON.stringify(testApiMutation.data, null, 2)}
                  </pre>
                </div>
              )}
              {testApiMutation.error && (
                <div>
                  <h3 className="font-semibold mb-2 text-destructive">Error</h3>
                  <pre className="text-sm overflow-auto bg-secondary rounded-md p-4 text-destructive">
                    {testApiMutation.error.message}
                  </pre>
                </div>
              )}
            </CardContent>
          </Card>
        )}
      </section>
    </div>
  );
}
